import { render } from "./RetrievePass.vue?vue&type=template&id=4772e433&scoped=true&ts=true"
import script from "./RetrievePass.vue?vue&type=script&lang=ts"
export * from "./RetrievePass.vue?vue&type=script&lang=ts"

import "./RetrievePass.vue?vue&type=style&index=0&id=4772e433&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4772e433"]])

export default __exports__